import {
  IconBarcode,
  IconCopy,
  IconDelivery,
  IconPills,
  IconTag,
} from '@redteclab/icons'
import classNames from 'clsx'
import type { VFC } from 'react'

import SvgIcon from 'views/components/atoms/Icon/SvgIcon'
import ButtonImage from 'views/components/molecules/ButtonImage'
import Collapsible from 'views/components/organisms/Collapsible'
import {
  IMAGE_MAX_WIDTH,
  IMAGE_MIN_WIDTH,
  IMAGE_SIZES,
} from 'views/components/organisms/FilteredProductList/consts'
import { CLASS_SELECTABLE } from 'views/components/organisms/FilteredProductList/SearchProductListItem/consts'
import { type SearchProductListItemComponentProps } from 'views/components/organisms/FilteredProductList/SearchProductListItem/SearchProductListItemComponent'
import ProductImage from 'views/components/organisms/ProductImage'

import './SerpMobileLayoutExperimentV1.scss'

const serpMobileLaboutItV1Item: VFC<SearchProductListItemComponentProps> = ({
  searchProductListItemProps,
  className,
  highlighted,
  highlightedProductLabel,
  productUrl,
  imageProps,
  lazyLoadImage,
  titleClassName,
  isItemWithMultipleVariantAttributes,
  quantityUnit,
  pharmaForm,
  pzn,
  manufacturer,
  productStatus,
  isRebrandingEnabled,
  renderProductItemLinkWithIcon,
  descriptionShort,
  retailPriceComponent,
  unitPricingComponent,
  listPriceWithDiscount,
  sellerBoxComponent,
  renderProductVariantsBox,
  redpointsMultiplier,
}) => {
  const { name } = imageProps

  return (
    <li
      {...searchProductListItemProps}
      className={classNames(
        className,
        'o-SearchProductListItem__cro-2020-variant1'
      )}
      data-clientside-hook="productDetailButton"
    >
      {highlighted && (
        <div className="o-SearchProductListItem__highlighted-area u-border u-border-radius--top-left u-border-radius--top-right a-h3">
          {highlightedProductLabel}
        </div>
      )}
      <div className="l-flex l-flex--wrap">
        <div className="l-col--4-of-12 u-no-padding u-padding--right@tiny o-FilteredProductListItem__image">
          <ButtonImage
            name={`product-${name}-image-link`}
            href={productUrl}
            noBorder
          >
            <ProductImage
              {...imageProps}
              lazyLoad={lazyLoadImage}
              sizes={IMAGE_SIZES}
              minWidth={IMAGE_MIN_WIDTH}
              maxWidth={IMAGE_MAX_WIDTH}
            />
          </ButtonImage>
        </div>

        <div className="l-col--8-of-12 u-padding--right o-FilteredProductListItem__content">
          {redpointsMultiplier > 1 && (
            <a
              className="o-SearchProductListItem__redpointsLabel u-font-weight--bold"
              href={productUrl}
            >
              <span className="o-ProductStatus--dot u-display--inline-block u-margin-xx-small--right" />
              <i>{redpointsMultiplier}x</i>
            </a>
          )}
          <div className="o-FilteredProductListItem__description">
            <div className="u-margin--bottom o-FilteredProductListItem__title-wrapper">
              <a className={titleClassName} href={productUrl} draggable={false}>
                {name}
              </a>
            </div>
            {renderProductVariantsBox}
            {descriptionShort && (
              <a
                href={productUrl}
                draggable={false}
                className="a-link--neutral u-hidden@small-tiny"
              >
                <p className="a-h4-tiny o-SearchProductListItem__content__body__text">
                  {descriptionShort}
                </p>
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="l-flex l-flex--stretch-children">
        <div className="l-col--7-of-12 o-SearchProductListItem__collapsible">
          <Collapsible id={pzn} allScreensizes light>
            <div className={`${CLASS_SELECTABLE}`}>
              <ul className="o-SearchProductListItem__info-list u-margin--bottom u-margin-small--bottom@small-tiny">
                <li className="l-flex">
                  <SvgIcon component={IconDelivery} />
                  &nbsp;&nbsp;
                  {productStatus}
                </li>
                {!isItemWithMultipleVariantAttributes && (
                  <>
                    <li className="o-SearchProductListItem__info-list__item">
                      <span className="a-h4-tiny u-font-weight--bold o-SearchProductListItem__info__items">
                        <SvgIcon component={IconCopy} />
                        &nbsp;&nbsp;
                        {quantityUnit}
                      </span>
                    </li>
                    {pharmaForm && (
                      <li>
                        <span className="a-h4-tiny u-font-weight--bold o-SearchProductListItem__info__items">
                          <SvgIcon component={IconPills} />
                          &nbsp;&nbsp;
                          {pharmaForm}
                        </span>
                      </li>
                    )}
                  </>
                )}
                {manufacturer && (
                  <li className="u-color--grey o-SearchProductListItem__info-list__item">
                    <span className="a-h4-tiny o-SearchProductListItem__info__items">
                      <SvgIcon component={IconTag} />
                      &nbsp;&nbsp;
                      {manufacturer}
                    </span>
                  </li>
                )}
                <li>
                  <SvgIcon component={IconBarcode} />
                  &nbsp;&nbsp;
                  {pzn}
                </li>
              </ul>
            </div>
          </Collapsible>
        </div>
        <div className="l-col--5-of-12">
          <div className="l-flex l-flex--distribute-space l-flex--end l-flex--wrap o-SearchProductListItem__content__buy-section">
            <div className="u-margin--right o-SearchProductListItem__content__buy-section-wrapper">
              <div className="l-flex o-SearchProductListItem__prices__retail-price-wrapper">
                {listPriceWithDiscount}
                {retailPriceComponent}
              </div>
              <div className="l-flex l-flex--justify-content--end">
                {unitPricingComponent}
              </div>
            </div>
            {sellerBoxComponent}
          </div>
        </div>
        {isRebrandingEnabled && renderProductItemLinkWithIcon}
      </div>
    </li>
  )
}

export default serpMobileLaboutItV1Item
